import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: '',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index')
    }, {
      path: '/select',
      name: 'select',
      component: () => import('@/views/select')
    }, {
      path: '/detail',
      name: 'detail',
      component: () => import('@/views/detail')
    },
    {
      path: '/contsUs',
      name: 'contsUs',
      component: () => import('@/views/contsUs')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/search')
    }, {
      path: '/message',
      name: 'message',
      component: () => import('@/views/message')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js